import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  SezioneCensimentoDocumenti
} from 'src/app/common/models/sezioni/sezione-censimento-documenti/sezione-censimento-documenti';
import { Provenienza } from 'src/app/common/models/tipologiche/provenienza';
import { TipoDocumento } from 'src/app/common/models/tipologiche/tipo-documento';
import { DocumentoAllegato } from '../../../models/documento-allegato';


@Component({
    selector: '[lista_documenti_tipo_documento]',
  templateUrl: 'lista-documenti-tipo-documento.component.html'
})

export class ListaDocumentiTipoDocumentoComponent {

  isTipoDocumentoChecked: boolean = false;
 @Input()
 isSchedaAnalitica:boolean=false

 @Input()
  writable: boolean;

  @Output()
  onClickUpdateDocVersion = new EventEmitter();

  @Output()
  onClickShowVersionHistory = new EventEmitter();

  @Output()
  onClickAddDocument = new EventEmitter();

  @Output()
  onClickRemoveDocument = new EventEmitter();

  // censimento documenti
  @Output()
  onClickAddDocumento = new EventEmitter();
  @Output()
  onClickEditDocumento = new EventEmitter();
  @Output()
  onClickDeleteDocumento = new EventEmitter();
  // fine

  @Output()
  onClickMoveDocument = new EventEmitter();

  @Output()
  onClickUpdateMetadatiModal = new EventEmitter();

  @Output()
  onReturnUpdate = new EventEmitter();

  @Input()
  tipoDocumento: TipoDocumento;

  @Input()
  sezione: SezioneCensimentoDocumenti;

  @Input()
  provenienza: Provenienza;

  @Input()
  sezioni: Array<any>;

  @Input()
  fascicolo: any;

  @Input()
  addDocFormTitles: Array<string>;

  canDeleteTipoDocumento():boolean {
    return !!(this.getDocumentiByTipoDocumento().length == 0);
  }

  // canAddDocument():boolean {
  //   return (this.getDocumentiByTipoDocumento().length < this.getQuantitaByTipoDocumento());
  // }

  getDocumentiByTipoDocumento() : DocumentoAllegato[]{
    let documenti: DocumentoAllegato[] = [];
    if(this.sezione.documenti){
      this.sezione.documenti.forEach(documento=>{
      if(documento.provenienza.id === this.provenienza.id && documento.tipoDocumento.id === this.tipoDocumento.id){
        documenti.push(documento);
      }
      });
    }
    return documenti;
  }

  getQuantitaByTipoDocumento() : number{
    let quantita: number = 0;
    if(this.sezione.censimentoDocumenti){
      this.sezione.censimentoDocumenti.forEach(censimento=>{
      if(censimento.tipoProvenienzaDocumento.id === this.provenienza.id && censimento.tipoDocumento.id === this.tipoDocumento.id){
        quantita = quantita + Number.parseInt(censimento.quantita.toString());
      }
      });
    }
    return quantita;
  }

  runMethodCensimentoDocumentiOption(method: string){
    switch(method){
      case 'add':
        this.onClickAddDocumento.emit({
          tipoDocumento: this.tipoDocumento,
          quantita: this.getQuantitaByTipoDocumento()
        })
        break;
      case 'edit':
        this.onClickEditDocumento.emit({
          tipoDocumento: this.tipoDocumento,
          quantita: this.getQuantitaByTipoDocumento()
        })
        break;
      case 'delete':
        this.onClickDeleteDocumento.emit({
          tipoDocumento: this.tipoDocumento,
          quantita: this.getQuantitaByTipoDocumento()
        })
        break;
      default:
        break;

    }
  }

  showUploadNewVersionModal(documento: DocumentoAllegato) {
    this.onClickUpdateDocVersion.emit(documento);
  }

  showHistoryModal(documento: DocumentoAllegato) {
    this.onClickShowVersionHistory.emit(documento);
  }

  showAddDocModal(nomeCampoId) {
    console.log(nomeCampoId);
    this.onClickAddDocument.emit(this.addDocFormTitles[nomeCampoId]);
  }

  showMoveDocumentModal(event){
    this.onClickMoveDocument.emit(event);
  }

  showUpdateMetadatiModal(documento: DocumentoAllegato) {
    this.onClickUpdateMetadatiModal.emit(documento);
  }

  removeDoc(documento: DocumentoAllegato) {
    this.onClickRemoveDocument.emit(documento);
  }

  onReturnUpdateCallback(response) {
    this.onReturnUpdate.emit(response);
  }
}
